import {useQuery} from 'react-query';
import getAdvertisements from '.';

const useGetAdverisements = (
  payload: IAdvertisementProps,
  enabled: boolean = true,
) => {
  const {data, isLoading} = useQuery(
    ['get-advertisements', payload],
    () => getAdvertisements(payload),
    {
      enabled,
    },
  );
  return {advertisementList: data, isLoading};
};

export default useGetAdverisements;
